import { Button, FormControl, FormLabel, Input, Text, Textarea } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { fetchCompany, updateHeaderSection } from '../../../../../store/actions';
import { useAppDispatch, useAppSelector } from '../../../../../hooks';

import { AppDispatch } from '../../../../../store';
import { headerSectionFormValidation } from '../../../../../utils';
import { headerSectiontype } from '../../../../../types';
import { useFormik } from 'formik';

export const HeaderSection = () => {

    const [isUpdatingHeaderSection, setIsUpdatingHeaderSection] = useState<boolean>(false);

    const { company } = useAppSelector(state => state.companyReducer);

    const { company_id, website } = company;

    const dispatch: AppDispatch = useAppDispatch();

    const headerSectionForm = useFormik({
        initialValues: {
            company_id: '',
            title: '',
            description: ''
        },
        validationSchema: headerSectionFormValidation,
        validateOnBlur: true,
        onSubmit: (values: headerSectiontype) => {
            setIsUpdatingHeaderSection(true);
            dispatch(updateHeaderSection(values))
                .then(() => { setIsUpdatingHeaderSection(false); dispatch(fetchCompany()); })
                .catch(() => setIsUpdatingHeaderSection(false));
        }
    });

    const setHeaderSectionValues = () => {
        headerSectionForm.setFieldValue('company_id', company_id);
        headerSectionForm.setFieldValue('title', website?.title);
        headerSectionForm.setFieldValue('description', website?.description);
    };

    useEffect(() => {
        setHeaderSectionValues();
    }, []);

    return (
        <>
            <form onSubmit={headerSectionForm.handleSubmit}>
                <FormControl isRequired mt={2}>
                    <FormLabel>Title</FormLabel>
                    <Input name='title' placeholder='Enter page title'
                        value={headerSectionForm.values.title}
                        onChange={headerSectionForm.handleChange}
                        onBlur={headerSectionForm.handleBlur}
                        isRequired
                        _focusVisible={{
                            boxShadow: '0 0 0 1px #ffc107'
                        }}
                    />
                    {headerSectionForm.errors.title && <Text color={'red.500'} fontSize={'xs'}>{headerSectionForm.errors.title}</Text>}
                </FormControl>
                <FormControl isRequired mt={3}>
                    <FormLabel>Description</FormLabel>
                    <Textarea name='description' placeholder='Enter page description' value={headerSectionForm.values.description} onChange={headerSectionForm.handleChange}
                        onBlur={headerSectionForm.handleBlur}
                        isRequired
                        _focusVisible={{
                            boxShadow: '0 0 0 1px #ffc107'
                        }}
                    ></Textarea>
                    {headerSectionForm.errors.description && <Text color={'red.500'} fontSize={'xs'}>{headerSectionForm.errors.description}</Text>}
                </FormControl>
                <Button
                    my={3}
                    float={'right'}
                    colorScheme={'yellow'}
                    type='submit'
                    isDisabled={isUpdatingHeaderSection || !headerSectionForm.isValid}
                    isLoading={isUpdatingHeaderSection}
                >Update</Button>
            </form>
        </>
    );
};